(function () {

  'use strict';

  function pxAddGatewayToNetwork(
    toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        me: '=me',
        callback: '&callback'
      },
      templateUrl: 'app/components/networkProperties/addGatewayToNetwork/addGatewayToNetwork.template.html',
      link: function (scope) {

        scope.gatewayInvalid = true;
        scope.network = scope.context.network;
        var mac_regex = /\b((([0-9A-Fa-f]{2}:{1,17}){5}([0-9a-fA-F]{2}))|(([0-9A-Fa-f]{2}){5}([0-9a-fA-F]{2})))\b/i;
        var ip_regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i;
        scope.error = null;

        scope.gateway = {
          ip: null,
          mac: null
        };

        scope.runGatewayValidation = function () {
          var gatewayInvalid = false;
          scope.macAddressInvalid = true;
          scope.ipAddressInvalid = true;

          var mac = angular.copy(scope.gateway.mac);
          var ip = angular.copy(scope.gateway.ip);

          if ((mac && mac === '*') || (mac && mac_regex.test(mac))) {
            scope.macAddressInvalid = false;
          } else {
            scope.macAddressInvalid = true;
          }

          if (ip && ip_regex.test(ip)) {
            scope.ipAddressInvalid = false;
          } else {
            scope.ipAddressInvalid = true;
          }

          if (!scope.macAddressInvalid && !scope.ipAddressInvalid) {
            gatewayInvalid = false;
          } else {
            gatewayInvalid = true;
          }

          scope.gatewayInvalid = gatewayInvalid;
        };

        scope.addGateway = function () {
          var preFlightGateway = {
            ip: scope.gateway.ip,
            mac: cleanupGateway(scope.gateway.mac)
          };
          scope.network.addGateway(preFlightGateway, false).then(function (response) {
            toastr.success($filter("translate")("ChangesSaved"));
          }).catch(function (error) {
            scope.error = error;
          });
          scope.callback();
        };

        function cleanupGateway(mac) {
          if (mac === '*') {
            return mac;
          } else {
            return mac.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
          }
        }

        scope.clearError = function () {
          scope.error = null;
        };

      }
    };
  }

  pxAddGatewayToNetwork.$inject = ['toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxAddGatewayToNetwork', pxAddGatewayToNetwork);

})();
